<template>
  <div class="basic-container">
    <slot />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.basic-container {
  background: rgba(237, 237, 237, 1);
  min-height: 100vh;
  overflow: hidden;
}
</style>
